import React from 'react';
import { isMobile } from '../utils/deviceUtils';

export default function MobileZoomControls({
    isVisible,
    mobileZoomLevel,
    onZoomIn,
    onZoomOut
}) {
    const mobile = isMobile();

    if (!mobile || !isVisible) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            zIndex: 100
        }}>
            {/* Zoom In Button */}
            <button
                onClick={onZoomIn}
                disabled={mobileZoomLevel >= 5}
                style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    background: mobileZoomLevel >= 5 ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.2)',
                    color: mobileZoomLevel >= 5 ? 'rgba(255, 255, 255, 0.4)' : '#ffffff',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    cursor: mobileZoomLevel >= 5 ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 15px rgba(45, 0, 71, 0.3)',
                    transition: 'all 0.3s ease',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    touchAction: 'manipulation'
                }}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
                onMouseEnter={(e) => {
                    if (mobileZoomLevel < 5) {
                        e.target.style.background = 'rgba(45, 0, 71, 0.4)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                        e.target.style.transform = 'translateY(-2px)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (mobileZoomLevel < 5) {
                        e.target.style.background = 'rgba(0, 0, 0, 0.2)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                        e.target.style.transform = 'translateY(0)';
                    }
                }}
            >
                +
            </button>

            {/* Zoom Out Button */}
            <button
                onClick={onZoomOut}
                disabled={mobileZoomLevel <= 0.5}
                style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '8px',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    background: mobileZoomLevel <= 0.5 ? 'rgba(0, 0, 0, 0.1)' : 'rgba(0, 0, 0, 0.2)',
                    color: mobileZoomLevel <= 0.5 ? 'rgba(255, 255, 255, 0.4)' : '#ffffff',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    cursor: mobileZoomLevel <= 0.5 ? 'not-allowed' : 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 0 15px rgba(45, 0, 71, 0.3)',
                    transition: 'all 0.3s ease',
                    userSelect: 'none',
                    WebkitUserSelect: 'none',
                    touchAction: 'manipulation'
                }}
                onTouchStart={(e) => e.stopPropagation()}
                onTouchMove={(e) => e.stopPropagation()}
                onMouseEnter={(e) => {
                    if (mobileZoomLevel > 0.5) {
                        e.target.style.background = 'rgba(45, 0, 71, 0.4)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                        e.target.style.transform = 'translateY(-2px)';
                    }
                }}
                onMouseLeave={(e) => {
                    if (mobileZoomLevel > 0.5) {
                        e.target.style.background = 'rgba(0, 0, 0, 0.2)';
                        e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                        e.target.style.transform = 'translateY(0)';
                    }
                }}
            >
                −
            </button>
        </div>
    );
}
